// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const RoleManagerIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M10.85 1.5c3.07 0 5.56 2.49 5.56 5.55 0 3.07-2.49 5.55-5.56 5.55S5.3 10.12 5.3 7.05 7.8 1.5 10.85 1.5M21.6 17.91c0-.24 0-.48-.12-.72-.13-.24-.37-.36-.6-.36l-1.82-.25-.72-1.56c-.12-.12-.24-.37-.36-.37-.25-.12-.49-.12-.73-.12-.24.12-.48.24-.6.49l-.85 1.56-1.69.25c-.24 0-.36.12-.48.24-.36.36-.36.96 0 1.33l1.2 1.2-.23 1.7c0 .23 0 .36.12.6.12.36.48.48.84.48.12 0 .24 0 .48-.12l1.57-.85 1.57.73c.12.12.36.12.6.12.49-.12.85-.6.73-1.09l-.24-1.69 1.2-1.2s0-.25.13-.37" />
      <path
        d="M9.65 15.02c-1.7 0-3.26.24-4.47.6-.72.24-1.45.6-1.93 1.09-.48.48-.85 1.2-.85 2.05s.25 1.45.85 2.05c.48.48 1.2.85 1.93 1.09 1.2.36 2.78.6 4.47.6.72 0 1.2-.48 1.2-1.2v-5.08c0-.72-.48-1.2-1.2-1.2"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default RoleManagerIcon;
